<div class="capacity-by-person">
  <!-- Filters Row (Horizontal) -->
  @if (isFilterVisible) {
    <div class="filters-row">
      <div class="horizontal-filters-container">
        <!-- Date Range Filter -->
        <div class="filter-item">
          <label>Date Range</label>
          <div class="calendar-container">
            <p-calendar
              [(ngModel)]="dateRangeValue"
              selectionMode="range"
              [readonlyInput]="true"
              [showIcon]="true"
              [minDate]="minDateValue"
              [maxDate]="maxDateValue"
              dateFormat="mm/dd/yy"
              placeholder="Select date range"
              [style]="{'width':'100%'}"
              [yearNavigator]="true"
              [monthNavigator]="true"
              yearRange="2020:2050">
            </p-calendar>
          </div>
        </div>
        <!-- TK Filter -->
        <div class="filter-item">
          <label>TK</label>
          <ng-select
            [items]="tkOptions"
            bindLabel="name"
            bindValue="id"
            placeholder="Select TK"
            [(ngModel)]="filters.tkId"
            [clearable]="true"
            class="custom-select multiline-dropdown">
          </ng-select>
        </div>
        <!-- Practice Area Filter -->
        <div class="filter-item">
          <label>Practice Area</label>
          <ng-select
            [items]="practiceAreaOptions"
            bindLabel="name"
            bindValue="id"
            placeholder="Select Practice Area"
            [(ngModel)]="filters.practiceAreaId"
            [clearable]="true"
            class="custom-select multiline-dropdown">
          </ng-select>
        </div>
        <!-- Apply and Clear Filters -->
        <div class="filter-actions">
          <button class="btn btn-primary apply-btn" (click)="applyFilters()">Apply</button>
          <button class="btn btn-outline-secondary clear-btn" (click)="resetFilters()">
            <i class="bx bx-x-circle"></i> Clear
          </button>
        </div>
      </div>
    </div>
  }

  <!-- Chart Row -->
  <div class="row">
    <!-- Chart Column (Full Width) -->
    <div class="col-12 chart-column">
      <div #chartContainer class="chart-container">
        <!-- Loading indicator -->
        @if (loading) {
          <div class="loading-container">
            <div class="loading-spinner"></div>
          </div>
        }

        <!-- No data message -->
        @if (noData && !loading && !error) {
          <div class="no-data-message">
            No capacity data available for the selected filters.
          </div>
        }

        <!-- Error message -->
        @if (error) {
          <div class="error-container">
            <div class="alert alert-danger">
              {{ error }}
              <button class="btn btn-sm btn-outline-danger ml-2" (click)="loadData()">Retry</button>
            </div>
          </div>
        }

        <!-- Chart -->
        @if (!loading && !error && !noData) {
          <div class="chart-wrapper">
            @if (gaugeData && gaugeData.length > 0) {
              <ngx-charts-gauge
                [view]="view"
                [scheme]="colorScheme"
                [results]="gaugeData[0].series"
                [min]="gaugeMin"
                [max]="gaugeMax"
                [units]="gaugeUnits"
                [angleSpan]="gaugeAngleSpan"
                [startAngle]="gaugeStartAngle"
                [showAxis]="gaugeShowAxis"
                [bigSegments]="10"
                [smallSegments]="5"
                [legend]="legend"
                [legendPosition]="legendPosition"
                [legendTitle]="legendTitle"
                [textValue]="remainingTimeText">
              </ngx-charts-gauge>
            }
            @if (!gaugeData || gaugeData.length === 0) {
              <div class="no-data-message">
                Preparing capacity data...
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
